export const emailInfos = [
	{ subject: 'Geoportal', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Mapa', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Metadados', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Mapoteca Digital', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Emissão de Documentos', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Tutoriais', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Portal Cidadão', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Legislação Urbanística', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Aprovação de Projetos', recipient: 'cassiano.rsd@gmail.com' },
	{
		subject: 'Acervo Cartográfico Cadastral',
		recipient: 'cassiano.rsd@gmail.com',
	},
	{ subject: 'Divinópolis em Dados', recipient: 'cassiano.rsd@gmail.com' },
	{ subject: 'Outros', recipient: 'cassiano.rsd@gmail.com' },
];
